module.exports = __webpack_public_path__ + "img/diangoong.0979f461.png";